import { Component, Input, Output, EventEmitter, NgZone, Renderer2, AfterViewInit } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import { DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { v_DispatchAttachmentBus } from '../../shared/models/v_DispatchAttachmentBus';
import { DispatchesService } from '../../shared/services/dispatches.service';
import { DomSanitizer } from '@angular/platform-browser';
import { CDocument } from '../../shared/models/CDocument';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { take, tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { Subject, Subscription, fromEvent } from 'rxjs';

@Component({
    selector: 'dispatch-attachments',
    templateUrl: './dispatch-attachments.component.html',
    styleUrls: ['./dispatch-attachments.component.scss']
})
export class DispatchAttachmentsComponent extends BaseGridUIComponent<v_DispatchAttachmentBus, null, DispatchesService> implements AfterViewInit {

    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    renderer: Renderer2;
    @Input() canDrag: boolean = false;

    constructor(svc_data: DispatchesService, globals: GlobalsService, renderer: Renderer2, private zone: NgZone, private sanitizer: DomSanitizer) {
        super(globals);
        this.svc_data = svc_data;
        this.renderer = renderer;
    }

    hide() {
        this.active = false;
    }
    active: boolean = false;
    documentData: any = "";
    documentDataURL: any;
    document: CDocument;

    view(data: v_DispatchAttachmentBus) {
        this.svc_data.getDocument(data.dispatchAttachmentDetailId).subscribe(data => {
            this.document = new CDocument(data);
            this.documentData = this.sanitizer.bypassSecurityTrustResourceUrl("data:" + this.document.mimeType + ";base64," + data.documentB64String);

            var binary = atob(data.documentB64String.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            this.documentDataURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([view], { type: "application/pdf" })));
            this.active = true;
        });
    }
    download(data: v_DispatchAttachmentBus) {
        this.svc_data.getDocument(data.dispatchAttachmentDetailId).subscribe(data => {
            this.document = new CDocument(data);
            let downloadData = "data:" + this.document.mimeType + ";base64," + data.document;
            saveAs(downloadData, this.document.fileName);
        });
    }
    uploadSaveUrl: string;
    uploadRemoveUrl: string;
    uploadRestrictions: any;

    selectEventHandler(e: any) {

    }
    clearEventHandler(e: any) {

    }
    removeEventHandler(e: any) {

    }
    completeEventHandler(e: any) {

    }
    getDragReady() {

        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }
        if (this.canDrag) {
            this.zone.onStable.pipe(take(1))
                .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
        }
    }
    processGridData() {
        this.getDragReady();
    }
    public ngAfterViewInit(): void {
        this.getDragReady();
    }
    public dataStateChange(state: DataStateChangeEvent): void {
        if (state && state.group) {
            state.group.map(group => group.aggregates = this.aggregates);
        }
        this.state = state;
        this.getDragReady();
    }
    private handleDragAndDrop(): Subscription {
        const sub = new Subscription(() => { });
        let draggedItemIndex;
        const tableRows = Array.from(document.querySelectorAll('div.attachmentGridDiv > .k-grid tr'));
        const _this = this;
        tableRows.forEach(item => {
            this.renderer.setAttribute(item, 'draggable', 'true');
            const dragStart = fromEvent<DragEvent>(item, 'dragstart');
            const dragOver = fromEvent(item, 'dragover');
            const dragEnd = fromEvent(item, 'dragend');
            var dropItemIndex;
            var dataItem;
            sub.add(dragStart.pipe(
                tap(({ dataTransfer }) => {
                    try {
                        // Firefox won't drag without setting data
                        dataTransfer.setData('application/json', "");
                    } catch (err) {
                        // IE doesn't support MIME types in setData
                    }
                })
            ).subscribe(({ target }) => {
                const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                draggedItemIndex = row.rowIndex;
                var data = _.cloneDeep(this.grid.data);
                dataItem = data.data[draggedItemIndex];
            }));

            sub.add(dragEnd.subscribe((e: any) => {
                e.preventDefault();
                var event = _.cloneDeep(dataItem);
                event.detailType = 3;
                event.dropid = event.dispatchAttachmentId;

                this.dropEvent.emit(event);
            }));
        });

        return sub;
    }

}

